import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import models from "../../../../types/models";
import PersonalAccount from "../../../../store/PersonalAccount";

export default observer(function CardTitle({ card }) {
  CardTitle.propTypes = {
    countCard: PropTypes.number,
    i: PropTypes.number,
    card: PropTypes.oneOfType([models.gameCard, models.compromiseGameCard]),
  };
  const gender = PersonalAccount.user?.gender;
  return (
    <div className="in-game-page__main__swipe-wrapper__wrapper__question">
      {gender
        ? gender === "male"
          ? card?.question_for_male
          : card?.question_for_female
        : null}
    </div>
  );
});
